import { render, staticRenderFns } from "./HelpChildInfo.vue?vue&type=template&id=5f479311&scoped=true&"
import script from "./HelpChildInfo.vue?vue&type=script&lang=js&"
export * from "./HelpChildInfo.vue?vue&type=script&lang=js&"
import style0 from "./HelpChildInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HelpChildInfo.vue?vue&type=style&index=1&id=5f479311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f479311",
  null
  
)

export default component.exports